import { AppBar, IconButton, Toolbar } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import React, { Component } from "react";
import { getUrlExtension, getFnameFromUrl } from "../../Handlers/getters";
import downloadIcon from "../../Assets/newicons/action/download/outline/download-outline-16px.svg";
import { downloadFile } from "../../Actions/AxiosInstance";

export function getDocViewFromExt({ docUrl, width, isbase64, ext }) {
  const ext1 = ext || getUrlExtension(docUrl);
  console.log("ext: ", ext1, ext, docUrl, isbase64);
  switch (ext1.toLowerCase()) {
    case "jpg":
    case "jpeg":
    case "png":
      return <ImgView docUrl={docUrl} width={width} />;
    case "pdf":
      return <PdfView docUrl={docUrl} width={width} isbase64={isbase64} />;
    case "ppt":
    case "pptx":
      return <PptView docUrl={docUrl} width={width} />;
    case "doc":
    case "docx":
    case "txt":
    case "text":
    case "rtf":
      return <DocView docUrl={docUrl} width={width} />;
    default:
      return null;
  }
}

const ImgView = ({ docUrl, width = "" }) => (
  <div style={{ height: "100%", width: "100%", overflow: "auto" }}>
    <img
      src={docUrl}
      style={{ objectFit: "cover", overflow: "auto", maxWidth: "80%" }}
      className={`${width}`}
    />
  </div>
);

const PdfView = ({ docUrl, isbase64 }) => {
  console.log("isbase64: ", isbase64);
  console.log("docUrl: ", docUrl);

  return (
    <div className="thin-scroll" style={{ height: "100vh", overflowY: "auto" }}>
      {!isbase64 ? (
        <embed
          className="height100  width100 holds-the-iframe"
          src={`${docUrl}`}
          alt="loading"
        />
      ) : (
        <embed
          className="height100 width100 holds-the-iframe"
          src={`${docUrl}`}
          alt="loading"
        />
      )}
    </div>
  );
};

const PptView = ({ docUrl }) => (
  <embed
    className="holds-the-iframe height100 width100"
    src={`https://view.officeapps.live.com/op/embed.aspx?src=${docUrl}`}
  />
);

// const DocView = ({ docUrl }) => <embed className="height100 width100" src={`https://docs.google.com/viewerng/viewer?url=${docUrl}`} />;

const DocView = ({ docUrl }) => (
  <embed
    className="holds-the-iframe height100 width100"
    src={`https://docs.google.com/gview?url=${docUrl}&embedded=true`}
  />
);

const TxtView = ({ docUrl }) => (
  <embed
    className="holds-the-iframe height100 width100"
    type="text/plain"
    src={docUrl}
  />
);

{
  /* <object className="height100 width100" type="text/html" data={docUrl.replace(".txt", ".html")} border="1" />; */
}
{
  /* <iframe className="height100 width100" src={`${docUrl}`} />; */
}

export default class DocViewer extends Component {
  render() {
    const { docUrl, onClose, name, isbase64, ext } = this.props;
    const h = window.innerHeight - 66;
    const fname = getFnameFromUrl(docUrl);
    return (
      <div className="hide-y">
        <AppBar color="inherit">
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <div className="flex-1 margin-left-20">{name || fname}</div>

            {!isbase64 && (
              <div
                className="inlineClass padding-left-20 cursurpointer"
                onClick={() => downloadFile(docUrl, name || fname)}
              >
                <img src={downloadIcon} />
              </div>
            )}
          </Toolbar>
        </AppBar>
        <div className="margin-top-64" />
        <div className="bg-color-f7f8f8" style={{ height: h }}>
          <div className="text-align-center" style={{ height: h }}>
            {getDocViewFromExt({ docUrl, isbase64, ext })}
          </div>
        </div>
      </div>
    );
  }
}
